import { request } from '@/utils/request'
import type { ApiResult } from '@/api/common'
import type { UserGroupQueryParams, UserGroupInfo, UserGroupUserList } from '@/types/userGroup'
import type { PageInfo } from '@/types/user'
import { MenuInfo } from '@/types/menu'


/**
 * 查询用户组列表
 */
export function getUserGroupList(params: UserGroupQueryParams) {
  return request<ApiResult<PageInfo<UserGroupInfo>>>({
    url: '/api/userGroup',
    method: 'get',
    params
  })
}

/**
 * 查询用户组列表及用户
 */
export function getUserGroupUserList() {
   return request<UserGroupUserList[]>({
     url: '/api/userGroup/user',
     method: 'get',
   })
 }

/**
 * 新增用户组
 */
export function addUserGroup(data: {
  name: string
  remark?: string
  menuIds: number[]
}) {
  return request<ApiResult<void>>({
    url: '/api/userGroup',
    method: 'post',
    data
  })
}

/**
 * 新增用户组
 */
export function addPresetUserGroup(data: {
  name: string
  remark?: string
  menuIds: number[]
}) {
  return request<ApiResult<void>>({
    url: '/api/userGroup/preset',
    method: 'post',
    data
  })
}

/**
 * 获取菜单树
 */
export function getMenuTree() {
  return request<MenuInfo[]>({
    url: '/api/auth/menu',
    method: 'get'
  })
}

// 修改用户组
export function updateUserGroup(id: number, data: {
  name: string
  remark?: string
  menuIds: number[]
}) {
  return request<void>({
    url: `/api/userGroup/${id}`,
    method: 'PUT',
    data
  })
}

/**
 * 获取用户组详情
 * @param id 用户组ID
 */
export function getUserGroupDetail(id: number) {
  return request<ApiResult<UserGroupInfo>>({
    url: `/api/userGroup/${id}`,
    method: 'get'
  })
}

/**
 * 删除用户组
 * @param id 用户组ID
 */
export function deleteUserGroup(id: number) {
  return request<ApiResult<void>>({
    url: `/api/userGroup/${id}`,
    method: 'delete'
  })
}

